export default __webpack_public_path__ + "static/media/u_wdt_c_1_2.d353d082.mp3";